import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useSearchParams } from '../../hooks/useSearchParams';
import { useSearchResultsQuery } from '../../search-results/hooks/useSearchResultsQuery';
import { useFilterTags } from '../hooks/useFilterTags';
import { ClearFiltersButton } from './ClearFiltersButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FilterTags() {
  var _data$result$total;
  const params = useSearchParams();
  const filterTags = useFilterTags();
  const {
    data
  } = useSearchResultsQuery();
  return /*#__PURE__*/_jsxs(Flex, {
    flexWrap: "wrap",
    gap: "200",
    marginBlockStart: "200",
    paddingInlineEnd: "400",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceStorefront.searchResults.resultCount",
      options: {
        count: (_data$result$total = data === null || data === void 0 ? void 0 : data.result.total) !== null && _data$result$total !== void 0 ? _data$result$total : 0
      }
    }), filterTags.map(tag => /*#__PURE__*/_jsx(Tooltip, {
      title: tag.tooltip,
      children: /*#__PURE__*/_jsx(Tag, {
        marginInlineStart: "0 !important",
        closeable: true,
        onCloseClick: () => params.deleteFromList(tag.field, tag.value),
        use: "info",
        children: tag.text
      })
    }, `${tag.field}-${tag.text}`)), filterTags.length > 0 && /*#__PURE__*/_jsx(ClearFiltersButton, {})]
  });
}